import { Injectable } from '@angular/core';
import { ApiController } from 'app/controllers/api-controller.interface';
import { InfracaoTransporteDTO, InfracaoTransporteDTOList } from 'app/model/dtos/mob/infracao-transporte-dto';

import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { environmentv3 } from './../../../environments/environment-v3';

@Injectable()
export class InfracaoTransporteController implements ApiController<InfracaoTransporteDTO>{

    constructor() { }

    find(filters?: IFilter): Promise<InfracaoTransporteDTO[]> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/infracaotransporte',
                    environment: environmentv3,
                    filter: filters,
                }),
            }),
            new HttpResponse(new Array<InfracaoTransporteDTO>())
        );
        return request.call();
    }
    
    findInfracoes(filters?: IFilter): Promise<InfracaoTransporteDTO[]> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/infracaotransporte/listar',
                    environment: environmentv3,
                    filter: filters,
                }),
            }),
            new HttpResponse(new Array<InfracaoTransporteDTO>())
        );
        return request.call();
    }

    getInfracoes(filters?: IFilter): Promise<InfracaoTransporteDTOList> {
        
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/infracaotransporte/infracoes',
                    environment: environmentv3,
                    filter: filters,
                }),
            }),
            new HttpResponse(new InfracaoTransporteDTOList())
        );
        return request.call();
    }


    get(id: number): Promise<InfracaoTransporteDTO> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/infracaotransporte/:cdInfracao',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdInfracao: id
                    }),
                }),
            }),
            new HttpResponse(new InfracaoTransporteDTO())
        );
        return request.call();
    }
    
    create(entity: InfracaoTransporteDTO): Promise<InfracaoTransporteDTO> {
        let request = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'mob/infracaotransporte',
                    environment: environmentv3
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new InfracaoTransporteDTO()
            )
        );
        return request.call();
    }

    update(entity: InfracaoTransporteDTO): Promise<InfracaoTransporteDTO> {
        let request = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'mob/infracaotransporte/:cdInfracao',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdInfracao: entity.cdInfracao
                    })
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new InfracaoTransporteDTO()
            )
        );
        return request.call();
    }
}